import { Casette as o } from "./casette.js";
import { MusicBox as r } from "./music-box.js";
import { DjSet as m } from "./djset.js";
import { Headphone as t } from "./headphone.js";
import { GettoBlaster as i } from "./gettoblaster.js";
import { Microphone2 as p } from "./microphone-2.js";
import { Banjo as f } from "./banjo.js";
import { Guitar as e } from "./guitar.js";
import { Trumpet as a } from "./trumpet.js";
import { Sound as n } from "./sound.js";
import { GrammaPhone as s } from "./grammaphone.js";
import { EarPods as l } from "./earpods.js";
import { Education as c } from "./education.js";
import { Microphone as h } from "./microphone.js";
import { Megaphone as u } from "./megaphone.js";
import { Equalizer as B } from "./equalizer.js";
import { Speaker as d } from "./speaker.js";
import { Help as M } from "./help.js";
import { Target as S } from "./target.js";
import { TargetArrow as g } from "./target-arrow.js";
import { Speed as C } from "./speed.js";
import { Membership as b } from "./membership.js";
import { Birdhouse as P } from "./birdhouse.js";
import { Vr as R } from "./vr.js";
import { RobotMini as T } from "./robot-mini.js";
import { ToyHorse as k } from "./toy-horse.js";
import { Drone as A } from "./drone.js";
import { Acting as y } from "./acting.js";
import { Skull as G } from "./skull.js";
import { Party as H } from "./party.js";
import { Rainbow as w } from "./rainbow.js";
import { Anchor as z } from "./anchor.js";
import { Trophy as E } from "./trophy.js";
import { Calculator as L } from "./calculator.js";
import { Puzzle as j } from "./puzzle.js";
import { Photos as x } from "./photos.js";
import { Abacus as D } from "./abacus.js";
import { Glasses as I } from "./glasses.js";
import { RocketLaunch as q } from "./rocket-launch.js";
import { BallSoccer as v } from "./ball-soccer.js";
import { BallBeach as F } from "./ball-beach.js";
import { BallBasketball as O } from "./ball-basketball.js";
import { Lenses as V } from "./lenses.js";
import { Resolution as J } from "./resolution.js";
import { Camera as K } from "./camera.js";
import { FrameRate as N } from "./frame-rate.js";
import { Codec as Q } from "./codec.js";
import { TwoAngle as U } from "./2-angle.js";
import { Chair as W } from "./chair.js";
import { Membercard as X } from "./membercard.js";
import { Console as Y } from "./console.js";
import { InnovationHeroes as Z } from "./innovation-heroes.js";
import { Magnet as _ } from "./magnet.js";
import { Poscast as $ } from "./poscast.js";
import { OfficeChair as oo } from "./office-chair.js";
import { Image as ro } from "./image.js";
import { StarSky as mo } from "./star-sky.js";
import { Ratio as to } from "./ratio-16x9.js";
const nr = {
  Casette: o,
  MusicBox: r,
  DjSet: m,
  Headphone: t,
  GettoBlaster: i,
  Microphone2: p,
  Banjo: f,
  Guitar: e,
  Trumpet: a,
  Sound: n,
  GrammaPhone: s,
  EarPods: l,
  Education: c,
  Microphone: h,
  Megaphone: u,
  Equalizer: B,
  Speaker: d,
  Help: M,
  Target: S,
  TargetArrow: g,
  Speed: C,
  Membership: b,
  Birdhouse: P,
  Vr: R,
  RobotMini: T,
  ToyHorse: k,
  Drone: A,
  Acting: y,
  Skull: G,
  Party: H,
  Rainbow: w,
  Anchor: z,
  Trophy: E,
  Calculator: L,
  Puzzle: j,
  Photos: x,
  Abacus: D,
  Glasses: I,
  RocketLaunch: q,
  BallSoccer: v,
  BallBeach: F,
  BallBasketball: O,
  Lenses: V,
  Resolution: J,
  Camera: K,
  FrameRate: N,
  Codec: Q,
  TwoAngle: U,
  Chair: W,
  Membercard: X,
  Console: Y,
  InnovationHeroes: Z,
  Magnet: _,
  Poscast: $,
  OfficeChair: oo,
  Image: ro,
  StarSky: mo,
  Ratio: to
};
export {
  nr as Leisure
};
